import * as yup from "yup";

export const bookSchema = yup
  .object({
    title: yup
      .string()
      .required()
      .min(3, "Title must be at least 3 characters.")
      .max(50, "Title cannot exceed 50 characters."),
    thumbnailUrl: yup.string().required("Thumbnail image is required."),
    pdfUrl: yup.string().required("PDF is required."),
    relevantSkills: yup
      .array()
      .of(yup.object().shape({ value: yup.string(), label: yup.string() })),
  })
  .required();

export const allowSchema = yup.object({
  accessList: yup.array().required(),
  allowedForAll: yup.boolean().required(),
});
